<template>
    <div id="home" v-loading.fullscreen.lock="changeLoading">
        <div style="background-color: white; margin: 10px 20px">
            <div class="pos_container_panel" style="padding-left: 2rem">
                <el-form :inline="true" class="demo-form-inline" style="margin-left: 6rem; padding-top: 2rem">
                    <el-row class="rowtop" style="padding-top: 2rem">
                        <el-col :span="12">
                            <el-form-item label="客户名称：" style="margin-bottom: 0; margin-left: 1rem">
                                <el-input @click="showClientName('search')" readonly v-model="searchForm.client"
                                    placeholder="请选择"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple-light" style="float: right;margin-right: 10rem;">
                                <el-button type="warning" class="harpIDbtn" size="default" @click="searchVirtualCard(1)">
                                    搜索</el-button>
                                <el-button type="warning" class="harpIDbtn" size="default" style="margin-left: 3rem"
                                    @click="addVirtualCard()">新增</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
                <hr style="margin: 1rem -14rem 0rem;background-color: rgb(241 243 245);height: 0.2rem;border: none;" />
                <el-table :data="tableData" style="width: 90%; margin-top: 50px; margin-left: 100px">
                    <el-table-column prop="id" v-if="false"> </el-table-column>
                    <el-table-column prop="customerCode" label="客户编号" align="center"></el-table-column>
                    <el-table-column prop="customerName" label="客户名称" align="center"></el-table-column>
                    <el-table-column prop="creditCardNumber" label="虚拟卡号" align="center" width="250"></el-table-column>
                    <el-table-column prop="cardName" label="持卡人姓名" align="center" width="250"></el-table-column>
                    <el-table-column prop="validData" label="有效期" align="center" width="250"></el-table-column>
                    <el-table-column :label="$t('ORDERLIST.Operation')" fixed="right" align="center" width="140">
                        <template #default="scope">
                            <el-button class="deleteShow" @click="editRow(scope.row)" type="text" size="small">
                                修改
                            </el-button>
                            <el-button class="deleteShow" @click="deleteRow(scope.row)" type="text" size="small">
                                {{ $t("ORDERLIST.DELETE") }}
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-footer style="margin: 1rem 2rem; background-color: #ffffff">
                    <el-pagination style="float: right; margin: 1rem 0" background layout="total,prev, pager, next"
                        :page-size="15" @current-change="handleCurrentChange" :total="totalCount"
                        v-model:current-page="Pageone">
                    </el-pagination>
                </el-footer>
            </div>
        </div>
        <!--新增 dialog-->
        <el-dialog title="虚拟卡" v-model="dialogFormVisible">
            <el-form :model="dataForm" :rules="checkInput" ref="dataForm">
                <el-form-item prop="customerName" label="客户名称:" :label-width="formLabelWidth">
                    <el-input @click="showClientName('add')" :disabled="customerdisabled" readonly
                        v-model="dataForm.customerName" placeholder="请选择"
                        style="width: 58%; margin-left: 85px"></el-input>
                </el-form-item>
                <el-form-item label="卡类型:" :label-width="formLabelWidth" prop="CreditCardCompanyCode">
                    <!-- <el-input v-model="dataForm.CreditCardCompanyCode" autocomplete="off"
                        style="width: 58%; margin-left: 85px"></el-input> -->
                    <el-select v-model="dataForm.CreditCardCompanyCode" class="holewidth"
                        style="width: 58%; margin-left: 85px">
                        <el-option v-for="item in cardTypes" :key="item.creditCardCompanyCode" :label="item.creditCardNameList[
                            $t('COMMONPARAM.RESPONSEDATA.SHOWTYPE')
                        ]
                            " :value="item.creditCardCompanyCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="信用卡卡号:" :label-width="formLabelWidth" prop="CreditCardNumber">
                    <el-input v-model="dataForm.CreditCardNumber" autocomplete="off"
                        style="width: 58%; margin-left: 85px"></el-input>
                </el-form-item>
                <el-form-item label="有效日期:" :label-width="formLabelWidth" prop="CreditCardDate">
                    <el-date-picker class="grey_input" format="MM/YYYY" v-model="dataForm.CreditCardDate"
                        :disabled-date="disabledDate" type="month" :placeholder="$t('MESSAGE.PLEASEINPUT')"
                        ref='datePicker' @focus="dateFocus" style="width: 58%; margin-left: 85px">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="持卡人姓名:" :label-width="formLabelWidth" prop="CardName">
                    <el-input v-model="dataForm.CardName" autocomplete="off"
                        style="width: 58%; margin-left: 85px"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button type="primary" @click="saveVirtualCard">保存</el-button>
                    <!-- <el-button @click="cancel()">取消</el-button> -->
                </div>
            </template>
        </el-dialog>
        <!--删除el-dialog-->
        <el-dialog title="" v-model="deletedialogVisible" width="18%">
            <div class="dialog-span-fixed">
                <div>
                    <svg-icon icon-class="exclamation" style="vertical-align: -0.5em;"></svg-icon>
                    <span style="margin-left:1rem;">请确认是否删除</span>
                </div>
            </div>
            <template #footer>
                <button class="s_btn btn_dialog" @click="handleDeleteClick">确 定</button>
                <el-button class="btn_dialog" style="padding: 0.2rem 2rem;" @click="cancelDelete">取 消</el-button>
            </template>
        </el-dialog>
        <ConfirmBoxs :centerDialogVisible="confirmFlag" :confirmMsg="confirmMsg" @setConfirmFlag="setConfirmFlag">
        </ConfirmBoxs>
        <ClientList :customerDialogVisible="clientListFlag" @setCustomerFlag="setCustomerFlag"
            @customerInfo="selectClient">
        </ClientList>
    </div>
</template>

<script>
import {
    searchHotelVirtualCard,
    deletehotelVirtualCard,
    geCreditCard,
    savehotelVirtualCard
} from "@/api/platformData";
import {
    getCreditType,
    isEnglish,
} from "@/utils/utils.js";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
export default {
    name: "HBEVirtualCard",
    components: {
        ConfirmBoxs,
        ClientList,
    },
    data() {
        //持卡人姓名正则 英文
        var validatePass = (rule, value, callback) => {
            if (value == "" || (value.indexOf("*") >= 0 && this.dataForm.id > 0)) {
                callback();
            }
            //英文 必须是全英加空格
            var regchina = new RegExp("^[\u4E00-\u9FA5]+$");
            if (!regchina.test(value) && !isEnglish(value)) {
                callback(new Error(this.$t("GUARANTEE.CARDNAMEVALIDATE")));
            } else {
                callback();
            }
        };
        //信用卡拦截
        var validatePassCard = (rule, value, callback) => {
            var CreditCard = require("credit-card");
            if (value.indexOf("*") >= 0 && this.dataForm.id > 0) {
                callback();
            }
            if (
                CreditCard.isValidCardNumber(
                    value,
                    getCreditType(this.dataForm.CreditCardCompanyCode)
                ) &&
                value != "4111111111111111"
            ) {
                callback();
            } else {
                callback(new Error(this.$t("GUARANTEE.RULECREDITVIL")));
            }
        };
        //有效期拦截
        var cardValidityDate = (rule, value, callback) => {
            if ((value == '' || value == null) && this.dataForm.id > 0) {
                callback();
            }
            if (value == '' || value == null) {
                callback(new Error(this.$t('GUARANTEE.RULEVALIDITYDATE')));
            }
            let monthStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
            if (new Date(value) >= monthStartDate) {
                callback();
            } else {
                callback(new Error(this.$t("GUARANTEE.RULEVALIDITYDATE3")));
            }
        };
        return {
            changeLoading: false,
            clientListFlag: false,
            confirmMsg: "",
            confirmFlag: false,
            openClient: "search",
            searchForm: {
                client: "",
                hotelCustomerCode: "",
            },
            tableData: [],
            totalCount: 0,
            Pageone: 1,
            deletedialogVisible: false,
            dataForm: {
                id: 0,
                customerCode: "",
                customerName: "",
                CreditCardCompanyCode: "",
                CreditCardNumber: "",
                CreditCardDate: '',
                CardName: "",
                createdBy: "",
                updateBy: "",
            },
            dialogFormVisible: false,
            customerdisabled: false,
            formLabelWidth: "150px",
            cardTypes: [],
            cardNameRule: validatePass,
            regxCard: validatePassCard,
            regxCardValidityDate: cardValidityDate,
        };
    },
    computed: {
        checkInput() {
            return {
                customerName: [{ required: true, message: this.$t("MANUAL.VALIDATECUSTOMERNAME"), trigger: ["blur", "change"], }],
                CreditCardCompanyCode: [{ required: true, message: "请选择银行卡类型", trigger: ["blur", "change"], },],
                CreditCardNumber: [
                    { required: true, message: "请输入卡号", trigger: ["blur", "change"], },
                    { validator: this.regxCard, trigger: ["blur"] }
                ],
                CreditCardDate: [
                    { validator: this.regxCardValidityDate, trigger: ["blur", "change"], }
                ],
                CardName: [
                    { validator: this.cardNameRule, trigger: ["blur"] }
                ],
            }
        },
    },
    mounted() {
        this.searchVirtualCard(1);
        geCreditCard({ params: { page: 1, par_page: 10 } })
            .then((res) => {
                this.submitLoading = false;
                if (res.code === 200) {
                    if (res.data.error.code != 0) {
                        this.confirmFlag = true;
                        this.confirmMsg = "获取信用卡类型失败";
                    } else {
                        let list = res.data.list;
                        this.cardTypes = list;
                    }
                } else {
                    this.confirmFlag = true;
                    this.confirmMsg = "获取信用卡类型失败";
                }
            })
            .catch((err) => {
                this.confirmFlag = true;
                this.confirmMsg = "获取信用卡类型失败";
            });
    },
    methods: {
        disabledDate(time) {
            return time.getTime() < Date.now();
        },
        dateFocus() {
            this.$nextTick(() => {
            // Element Plus 中日期选择器的引用方式
            const picker = this.$refs.datePicker
            if (picker && picker.picker) {
                picker.picker.showYearPicker()
            }
            })
        },
        // 弹出客户姓名窗口方法
        showClientName(type) {
            this.openClient = type;
            this.clientListFlag = true;
        },
        setConfirmFlag(value) {
            this.changeLoading = false;
            this.confirmFlag = value;
        },
        //选择客户
        selectClient(item) {
            if (this.openClient == 'search') {
                this.searchForm.hotelCustomerCode = item.customerCode;
                this.searchForm.client = item.customerName;
                this.searchVirtualCard(1);
            } else {
                this.dataForm.customerCode = item.customerCode;
                this.dataForm.customerName = item.customerName;
            }
        },
        searchVirtualCard(currPage) {
            let customerParam = {
                params: {
                    page: currPage,
                    per_page: 10,
                    customerCode: this.searchForm.hotelCustomerCode,
                },
            };
            let that = this;
            searchHotelVirtualCard(customerParam)
                .then((res) => {
                    if (res.code == 200) {
                        that.tableData = res.data.list;
                        that.totalCount = res.data.total;
                    }
                })
                .catch(function (error) {
                    that.tableData = [];
                    that.totalCount = 0;
                });
        },
        //分页
        handleCurrentChange(pageNum) {
            this.searhotelMark(pageNum);
            this.Pageone = pageNum;
        },
        setCustomerFlag(value) {
            this.clientListFlag = value;
        },
        saveVirtualCard() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let param = {
                        id: this.dataForm.id,
                        customerCode: this.dataForm.customerCode,
                        customerName: this.dataForm.customerName,
                        CreditCardCompanyCode: this.dataForm.CreditCardCompanyCode,
                        CreditCardNumber: this.dataForm.CreditCardNumber,
                        CreditCardDate: this.toAddValidate(this.dataForm.CreditCardDate),
                        CardName: this.dataForm.CardName,
                        createdBy: this.dataForm.id == "" ? "" : this.$objBaseInfo.loginID
                    }
                    savehotelVirtualCard(param)
                        .then((res) => {
                            if (res.code == 200) {
                                this.confirmMsg = "保存成功！";
                                this.confirmFlag = true;
                                this.dialogFormVisible = false;
                                this.searchVirtualCard(1);
                            } else {
                                this.confirmMsg = res.message;
                                this.confirmFlag = true;
                            }
                        })
                        .catch(function (error) {
                        });
                }
            })
        },
        editRow(row) {
            console.log(row);
            this.dataForm = {
                id: row.id,
                customerCode: row.customerCode,
                customerName: row.customerName,
                CreditCardCompanyCode: row.creditCardCompanyCode,
                CreditCardNumber: row.creditCardNumber,
                CardName: row.cardName,
            };
            this.customerdisabled = false;
            this.dialogFormVisible = true;
        },
        deleteRow(row) {
            this.deletedialogVisible = true;
            this.deleteparams = {
                params: {
                    id: row.id,
                },
            };
        },
        cancelDelete() {
            this.deletedialogVisible = false;
        },
        addVirtualCard() {
            this.dataForm = {
                id: 0,
                customerCode: "",
                customerName: "",
                CreditCardCompanyCode: "",
                CreditCardNumber: "",
                CreditCardDate: null,
                CardName: "",
                createdBy: "",
                updateBy: "",
            },
                this.customerdisabled = false;
            this.dialogFormVisible = true;
        },
        toAddValidate(validate) {
            if (validate == '' || validate == null) {
                return validate;
            }
            let tf = function (i) {
                return (i < 10 ? "0" : "") + i;
            };
            let date = new Date(validate);
            return (
                tf(date.getMonth() + 1) +
                date.getFullYear().toString().substring(2, 4)
            );
        },
        //信用卡有效期转换
        toValidate(validate) {
            if (validate) {
                //当年年份前两个字符
                const yyF = new Date().getFullYear().toString().substr(0, 2);
                if (validate.toString().length == 4) {
                    //时间格式 MMYY
                    const yyyyF = yyF + validate.toString().substr(2, 2);
                    const mmF = validate.toString().substr(0, 2);
                    return yyyyF + "-" + mmF + "-" + "01";
                } else if (
                    validate.toString().length == 5 &&
                    validate.toString().indexOf("/") > -1
                ) {
                    //时间格式 MM/YY
                    const dateArr = validate.split("/");
                    return yyF + dateArr[1] + "-" + dateArr[0] + "-" + "01";
                } else if (
                    //时间格式 yyyy-MM-ddThh:mm:ss.000Z
                    validate.toString().indexOf("T") > -1
                ) {
                    let shortDate = validate.toString().substr(0, 10);
                    return shortDate;
                } else {
                    console.log("信用卡有效期：", validate);
                }
            } else {
                console.log("信用卡有效期：", validate);
                return validate;
            }
        },
        async handleDeleteClick() {
            this.deletedialogVisible = false;
            await deletehotelVirtualCard(this.deleteparams)
                .then((res) => {
                    if (res.code == 200) {
                        this.confirmFlag = true;
                        this.confirmMsg = "删除成功";
                        this.searchVirtualCard(1);
                    } else {
                        this.confirmFlag = true;
                        this.confirmMsg = res.message;
                    }
                })
                .catch((err) => {
                });
        },
    }
}
</script>

<style scoped>
.harpIDbtn {
    width: 10rem;
    height: 3rem;
    padding: 0 !important;
    font-size: 1rem !important;
}
</style>